module.exports = __webpack_public_path__ + "img/flag-pink.86fce3a3.svg";